import { AuditActionEnum } from '@empathybroker/tsclient-play/dist/enums/audit-action.enum';

import { AuditSortFieldEnum, LocaleEnum } from '../enums';

import { AuditMessages, Dictionary } from '../models';

const AUDIT_MESSAGES_EN: AuditMessages = {
  search: {
    placeholder: 'Search a user or ID'
  },
  entry: {
    actions: {
      [AuditActionEnum.CREATE]: 'created an entry',
      [AuditActionEnum.UPDATE]: 'edited an entry',
      [AuditActionEnum.DELETE]: 'deleted an entry',
      [AuditActionEnum.PUBLISH]: 'published last changes',
      [AuditActionEnum.IMPORT]: 'imported new changes'
    },
    previousState: 'Previous state',
    nextState: 'Next state',
    changingElements: {
      created: '{count} added',
      updated: '{count} modified',
      deleted: '{count} removed'
    }
  },
  sort: {
    [AuditSortFieldEnum.DATE]: {
      label: 'Date',
      groups: {
        today: 'Today',
        yesterday: 'Yesterday'
      }
    }
  },
  loadMore: 'Load more',
  noDataFound: 'No activities found'
};

const AUDIT_MESSAGES_ES: AuditMessages = {
  search: {
    placeholder: 'Busca un usuario o ID'
  },
  entry: {
    actions: {
      [AuditActionEnum.CREATE]: 'creó una entrada',
      [AuditActionEnum.UPDATE]: 'editó una entrada',
      [AuditActionEnum.DELETE]: 'borró una entrada',
      [AuditActionEnum.PUBLISH]: 'publicó últimos cambios',
      [AuditActionEnum.IMPORT]: 'importó nuevos cambios'
    },
    previousState: 'Estado previo',
    nextState: 'Estado siguiente',
    changingElements: {
      created: '{count} añadido(s)',
      updated: '{count} modificado(s)',
      deleted: '{count} eliminado(s)'
    }
  },
  sort: {
    [AuditSortFieldEnum.DATE]: {
      label: 'Fecha',
      groups: {
        today: 'Hoy',
        yesterday: 'Ayer'
      }
    }
  },
  loadMore: 'Cargar más',
  noDataFound: 'No se han encontrado actividades'
};

export const AUDIT_MESSAGES: Dictionary<{ audit: AuditMessages }> = {
  [LocaleEnum.ENGLISH]: {
    audit: AUDIT_MESSAGES_EN
  },
  [LocaleEnum.SPANISH]: {
    audit: AUDIT_MESSAGES_ES
  }
};
